<template>
    <div>
        <topback title="IToken History" path="back"></topback>
        
        <md-drop-menu class="drop-menu" :data="dropdata" @change="drop_choose"/>
        <div class="itoken-list">
            <div class="scroll-list">
                <md-scroll-view  ref="listscrollView" :scrolling-x="false" @refreshing="$_onRefresh" :auto-reflow="true" :immediate-check-end-reaching="true"
                    @end-reached="$_onEndReached">
                    <md-scroll-view-refresh slot="refresh" slot-scope="{ scrollTop, isRefreshActive, isRefreshing }"
                        :scroll-top="scrollTop" :is-refreshing="isRefreshing" :is-refresh-active="isRefreshActive"
                        refresh-text="pull to refresh" refresh-active-text="release refreshable"
                        refreshing-text="refresh"></md-scroll-view-refresh>

                        <div v-if="nodata" class="customized">
                            <md-result-page img-url="/static/icon/noassets.png" text="Itoken has not been buy in this way" subtext="">
                            </md-result-page>
                            <md-button type="primary" round @click="go_tobuy">To buy</md-button>
                        </div>

                        <md-field class="historylist pt-0">
                            <itokenhisoryitem :u="u" :dropdata="dropdata" v-for="u in quota_list" v-bind:key="u.id"></itokenhisoryitem>
                        </md-field>
                    <md-scroll-view-more slot="more" :is-finished="isFinished" loading-text="Loading" finished-text="no more data">
                    </md-scroll-view-more>
                </md-scroll-view>
            </div>
        </div>
    </div>
</template>

<script>
import iconimg from '@/components/iconimg'
import pointtext from '@/components/pointtext'
import { getassetsrecord } from '@/request/api'
import topback from '@/components/topback'
import itokenhisoryitem from '@/views/my/itokenhisoryitem'

export default {
    name: 'itokenhistory',
    props: {
        method: {
            type: String,
            default: 'usdt'
        }
    },
    components: {
        iconimg,
        pointtext,
        topback,
        itokenhisoryitem
    },
    data() {
        return {
            quota_list: [],
            page: 1,
            limit: 10,
            isFinished: false,
            nodata: false,
            rtype: 'all',
            dropdata: [
                {
                    text: 'Please select a filter type',
                    options: [
                        {
                            value: 'all',
                            text: 'All'
                        },
                        {
                            value: 'all',
                            text: 'All'
                        },
                        {
                            value: 'recharge',
                            text: 'Buy',
                        },
                        {
                            value: 'deducted',
                            text: 'Deducted',
                        },
                        {
                            value: 'return',
                            text: 'Return',
                        },
                        {
                            value: 'reward',
                            text: 'Reward',
                        },
                        {
                            value: 'commission',
                            text: 'Commission',
                        },
                        {
                            value: 'usdtreward',
                            text: 'Usdt Reward',
                        },
                        {
                            value: 'add',
                            text: 'TT Add',
                        },
                        {
                            value: 'admindeducted',
                            text: 'TT deducted',
                        },
                        {
                            value: 'transferout',
                            text: 'Transfer out',
                        },
                        {
                            value: 'transferin',
                            text: 'Transfer In',
                        },
                        {
                            value: 'security',
                            text: 'Security Deposit',
                        },
                        {
                            value: 'backsecurity',
                            text: 'Return Security',
                        }
                    ],
                },
            ],
        }
    },
    created() {
    },
    mounted() {
        window.ScrollViewTrigger2 = () => {
            this.$refs.listscrollView.triggerRefresh();
        }
    },

    methods: {
        drop_choose(barItem, listItem){
            console.log(barItem, listItem);
            this.rtype = listItem.value;
            this.$_onRefresh();
        },
        $_onRefresh() {
            this.quota_list = [];
            this.page = 1;
            this.isFinished = true;
            this.get_list(true);
        },
        $_onEndReached() {
            if (this.isFinished) {
                return
            }
            this.get_list(false);
        },
        get_list(refresh) {
            this.$toast.loading("Loading..");

            getassetsrecord({
                page: this.page,
                limit: this.limit,
                type: this.rtype
            }).then(res => {
                this.$toast.hide();
                if (res.code === 200) {
                    if (res.data.count === 0) {
                        this.nodata = true;
                    } else {
                        this.nodata = false;
                        this.quota_list = this.quota_list.concat(res.data.result);
                    }
                    if (this.quota_list.length < res.data.count) {
                        this.page = this.page + 1;
                        this.isFinished = false;
                    } else {
                        this.isFinished = true;
                    }
                } else {
                    this.$toast.failed(res.errmsg);
                }
                if(refresh) {
                    this.$refs.listscrollView.finishRefresh();
                    this.$refs.listscrollView.finishLoadMore();
                } else {
                    this.$refs.listscrollView.finishLoadMore();
                }
            });
        },
        display_type(type) {
            let options = this.dropdata[0].options;
            let foundOption = options.find(option => option.value === type );
            return foundOption.text;
        },
        go_tobuy() {
            this.$router.push('/transaction');
        }
    }
}
</script>
<style scoped>
.itoken-list {
    margin-top: 1.77rem;
}
.drop-menu {
    margin-top: 1rem;
}
.scroll-list {
    height: 13rem;
}

.historylist>>>.md-cell-item-right {
    display: block;
    color: #000000;
    font-size: 0.28rem;
    text-align: right;
}

.customized {
    height: 6.76rem;
}
.customized >>> .md-result {
    height: 75% !important;
}
.noassets {
    margin-top: 1.5rem;
}

.noassets>>>.md-result-image {
    width: 1.6rem;
}

.noassets>>>.md-result-text {
    margin: 0;
    color: #01080f;
    font-size: 0.12rem;
}

.noassets>>>.md-result-subtext {
    margin-top: 0.16rem;
    color: red;
    font-size: 0.28rem;
}
</style>



// WEBPACK FOOTER //
// src/views/my/itokenhistory.vue